module.exports = __webpack_public_path__ + "static/media/All_yincang@2x.290da1cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/All_yincang@2x.png
// module id = 1703
// module chunks = 0 1